import { createFileRoute } from '@tanstack/react-router';
// `IntegrationsTab` also renders on another company's profile (a supplier's
// amfori link, `network/(pages)/(detail)/$companyId/integrations/index.tsx`)
// — it is not moved, only reused here for the caller's own company.
import { IntegrationsTab } from '@/app/(client)/network/-components/companyProfileTabs/integrations/IntegrationsTab';
import { useSessionStore } from '@/store/sessionStore';

export const Route = createFileRoute(
  '/(client)/company-settings/(pages)/integrations/',
)({
  component: IntegrationsRoute,
});

function IntegrationsRoute() {
  const companyId = useSessionStore(s => s.user?.companyId);
  if (!companyId) return null;
  return <IntegrationsTab companyId={companyId} isOwnCompany />;
}
